<template>
  <div>
    <ClientSearchList
      @init="handleClient_init"
      @submit="handleClient_submit"
    />

    <div class="columns my-0 is-multiline">
      <div class="column is-4">
        <kst-input floating-label load-on-focus
          field="Search" :data="searchData" :catalog="RecSearchCatalog"
          @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-output addons floating-label 
          field="ClientID" :data="searchData" :catalog="RecSearchCatalog"
        >
          <template #default>
            <kst-input floating-label
              field="Client" :data="searchData" :catalog="RecSearchCatalog"
              :disabled="clientDisabled" @input="handleInput"
            />
          </template>
          <template #right>
            <div class="control">
              <template v-if="searchData.ClientID === null">
                <kst-tooltip search-mode hover-only :content="RecSearchCatalog.ClientID.Label">
                  <kst-button search-mode @click="handleSearch_client"/>
                </kst-tooltip>
              </template>
              <template v-else>
                <kst-tooltip clear-mode hover-only :content="RecSearchCatalog.ClientID.Label">
                  <kst-button clear-mode @click="handleClear_client"/>
                </kst-tooltip>
              </template>
            </div>
          </template>
        </kst-output>
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="WarehouseID" :data="searchData" :catalog="RecSearchCatalog"
          :options="warehouseOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="Status" :data="searchData" :catalog="RecSearchCatalog"
          :options="statusOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="InvoiceDate" :data="searchData" :catalog="RecSearchCatalog"
          @input="handleInput"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Model from "../RecModel.js";
import RecSearchCatalog from "../RecSearchCatalog.js";
import Services from "../../../services/Api/RecServices.js";

import ClientSearchList from "../../Client/SearchList/CliScL.vue";

export default {
  components:{
    ClientSearchList
  },
  props: {
    searchData: Object,
    warehouseOptions: Object
  },
  data: () => ({
    RecSearchCatalog: RecSearchCatalog,
    // func
    showClientFunc: null
  }),
  computed: {
    clientDisabled() {
      return this.searchData.ClientID !== null;
    },
    statusOptions() {
     return Model.createStatusOptions(RecSearchCatalog.Status.Label);
    }
  },
  methods: {
    /*** by Client modal ***/

    handleClient_init(show) {
      this.showClientFunc = show;
    },
    handleClient_submit(data) {
      this.searchData.ClientID = data.ID;
      this.searchData.Client = data.Name;
      this.handleInput();
    },

    /*** custom ***/

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },

    handleSearch_client() {
      this.showClientFunc(Services.getRelatedClientList);
    },
    handleClear_client() {
      this.searchData.ClientID = null;
      this.searchData.Client = "";

      this.handleInput();
    }
  }
}
</script>